// import React, { useEffect, useState } from 'react';
// import ResumeBuilderLanding from './ResumeBuilderLanding';
// import StepUploadResume from './methods/upload/StepUploadResume';
// import StepLinkedInImport from './methods/components/linkedin/StepLinkedInImport';
// import { ScratchAIFlow } from './methods/scratchai';
// import ScratchResumeEditor from './methods/scratchai/ResumeEditor';
// import TopMenu from '../TopMenu';
// import './styles/ResumeBuilder.css';

// const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// const ResumeBuilder = ({ theme, toggleTheme }) => {
//   const [step, setStep] = useState('landing');
//   const [parsedData, setParsedData] = useState(null);
//   const [editorMeta, setEditorMeta] = useState(null);
//   const [editorLoading, setEditorLoading] = useState(false);
//   const [editorError, setEditorError] = useState('');

//   const handleLandingContinue = ({ method }) => setStep(method);

//   const backToLanding = () => {
//     setStep('landing');
//     setParsedData(null);
//     setEditorMeta(null);
//     setEditorLoading(false);
//     setEditorError('');
//   };

//   useEffect(() => {
//     if (step !== 'editor' || editorMeta || editorLoading || editorError) return;

//     let cancelled = false;

//     const initEditor = async () => {
//       setEditorLoading(true);
//       setEditorError('');

//       try {
//         const token = localStorage.getItem('token');
//         const experienceLevel = parsedData?.experience?.length ? 'Experienced' : 'Fresher';
//         const res = await fetch(`${API_BASE_URL}/api/resume-builder/initialise`, {
//           method: 'POST',
//           headers: {
//             'Content-Type': 'application/json',
//             ...(token ? { Authorization: `Bearer ${token}` } : {}),
//           },
//           body: JSON.stringify({
//             templateSlug: 'sidebar-teal',
//             experienceLevel,
//             industry: parsedData?.industry ?? null,
//           }),
//         });

//         if (!res.ok) throw new Error('Failed to initialise resume editor');

//         const data = await res.json();
//         if (cancelled) return;

//         setEditorMeta({
//           templateId: data.templateSlug ?? 'sidebar-teal',
//           styleConfigJson: data.styleConfigJson ?? null,
//           resumeId: data.resumeId ?? null,
//           prefillData: parsedData ?? data.prefillData ?? data.prefilledData ?? null,
//           atsScore: data.atsOverallScore ?? 0,
//           experience: experienceLevel,
//           studying: parsedData?.studying ?? null,
//           industry: parsedData?.industry ?? null,
//         });
//       } catch (err) {
//         if (!cancelled) {
//           console.error(err);
//           setEditorError('Could not start the resume editor. Please go back and try again.');
//         }
//       } finally {
//         if (!cancelled) setEditorLoading(false);
//       }
//     };

//     initEditor();

//     return () => {
//       cancelled = true;
//     };
//   }, [step, editorMeta, editorLoading, editorError, parsedData]);

//   if (step === 'scratch') {
//     return (
//       <ScratchAIFlow
//         theme={theme}
//         toggleTheme={toggleTheme}
//         onBack={backToLanding}
//       />
//     );
//   }

//   if (step === 'upload') {
//     return (
//       <div className={`rb-shell ${theme}`} data-theme={theme}>
//         <TopMenu theme={theme} toggleTheme={toggleTheme} />
//         <StepUploadResume
//           onComplete={(data) => {
//             setParsedData(data);
//             setStep('editor');
//           }}
//           onBack={backToLanding}
//           theme={theme}
//         />
//       </div>
//     );
//   }

//   if (step === 'linkedin') {
//     return (
//       <div className={`rb-shell ${theme}`} data-theme={theme}>
//         <TopMenu theme={theme} toggleTheme={toggleTheme} />
//         <StepLinkedInImport
//           onComplete={(data) => {
//             setParsedData(data);
//             setStep('editor');
//           }}
//           onBack={backToLanding}
//           theme={theme}
//         />
//       </div>
//     );
//   }

//   if (step === 'editor') {
//     if (editorLoading || !editorMeta) {
//       return (
//         <div className={`rb-shell ${theme}`} data-theme={theme}>
//           <TopMenu theme={theme} toggleTheme={toggleTheme} />
//           <div style={{ minHeight: '70vh', display: 'grid', placeItems: 'center', color: '#fff', padding: 24, textAlign: 'center' }}>
//             {editorError || 'Setting up your resume editor...'}
//           </div>
//         </div>
//       );
//     }

//     return (
//       <ScratchResumeEditor
//         theme={theme}
//         toggleTheme={toggleTheme}
//         templateId={editorMeta.templateId}
//         styleConfigJson={editorMeta.styleConfigJson}
//         experience={editorMeta.experience}
//         studying={editorMeta.studying}
//         industry={editorMeta.industry}
//         resumeId={editorMeta.resumeId}
//         prefillData={editorMeta.prefillData}
//         atsScore={editorMeta.atsScore}
//         onBack={backToLanding}
//       />
//     );
//   }

//   return (
//     <div className={`rb-shell ${theme}`} data-theme={theme}>
//       <TopMenu theme={theme} toggleTheme={toggleTheme} />
//       <ResumeBuilderLanding onContinue={handleLandingContinue} theme={theme} />
//     </div>
//   );
// };

// export default ResumeBuilder;

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ResumeBuilderLanding from './ResumeBuilderLanding';
import StepUploadResume from './methods/upload/StepUploadResume';
import StepLinkedInImport from './methods/components/linkedin/StepLinkedInImport';
import { ScratchAIFlow } from './methods/scratchai';
import TopMenu from '../TopMenu';
import './styles/ResumeBuilder.css';

const DEFAULT_TEMPLATE_ID = 'sidebar-teal';
const DEFAULT_EXPERIENCE_LEVEL = 'Fresher';

const ResumeBuilder = ({ theme, toggleTheme }) => {
  const navigate = useNavigate();
  const [step, setStep] = useState('landing');

  const handleLandingContinue = ({ method }) => {
    setStep(method);
  };

  const backToLanding = () => {
    setStep('landing');
  };

  const startEditor = (payload = {}) => {
    const resumeId = payload.resumeId || null;
    const templateId = payload.templateId || DEFAULT_TEMPLATE_ID;
    const styleConfigJson = payload.styleConfigJson || null;
    const prefillData = payload.prefillData || null;
    const experience = payload.experience || DEFAULT_EXPERIENCE_LEVEL;
    const studying = payload.studying ?? null;
    const industry = payload.industry ?? null;
    const atsScore = payload.atsScore ?? 0;

    const params = new URLSearchParams();
    if (resumeId) params.set('resumeId', resumeId);
    if (templateId) params.set('templateId', templateId);
    if (styleConfigJson) params.set('styleConfigJson', styleConfigJson);
    if (prefillData) params.set('prefillData', JSON.stringify(prefillData));
    if (experience) params.set('experience', experience);
    if (studying) params.set('studying', JSON.stringify(studying));
    if (industry) params.set('industry', industry);
    params.set('backTo', '/resume-builder');
    if (atsScore) params.set('atsScore', String(atsScore));

    navigate(`/resume-builder/editor/${resumeId || ''}?${params.toString()}`, {
      state: {
        resumeId,
        templateId,
        styleConfigJson,
        prefillData,
        experience,
        studying,
        industry,
        atsScore,
        backTo: '/resume-builder',
      },
    });
  };

  if (step === 'scratch') {
    return (
      <ScratchAIFlow
        theme={theme}
        toggleTheme={toggleTheme}
        onBack={backToLanding}
      />
    );
  }

  if (step === 'upload') {
    return (
      <div className={`rb-shell ${theme}`} data-theme={theme}>
        <TopMenu theme={theme} toggleTheme={toggleTheme} />
        <StepUploadResume
          onComplete={(data) => {
            startEditor({
              templateId: DEFAULT_TEMPLATE_ID,
              prefillData: data,
              experience: data?.experience?.length ? 'Experienced' : DEFAULT_EXPERIENCE_LEVEL,
              studying: data?.studying ?? null,
              industry: data?.industry ?? null,
            });
          }}
          onBack={backToLanding}
          theme={theme}
        />
      </div>
    );
  }

  if (step === 'linkedin') {
    return (
      <div className={`rb-shell ${theme}`} data-theme={theme}>
        <TopMenu theme={theme} toggleTheme={toggleTheme} />
        <StepLinkedInImport
          onComplete={(data) => {
            startEditor({
              templateId: DEFAULT_TEMPLATE_ID,
              prefillData: data,
              experience: data?.experience?.length ? 'Experienced' : DEFAULT_EXPERIENCE_LEVEL,
              studying: data?.studying ?? null,
              industry: data?.industry ?? null,
            });
          }}
          onBack={backToLanding}
          theme={theme}
        />
      </div>
    );
  }

  return (
    <div className={`rb-shell ${theme}`} data-theme={theme}>
      <TopMenu theme={theme} toggleTheme={toggleTheme} />
      <ResumeBuilderLanding
        onContinue={handleLandingContinue}
        theme={theme}
      />
    </div>
  );
};

export default ResumeBuilder;
